var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascriptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e8c932;}.cls-3{fill:#ffdd25;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m123.22,387.86l-25.5-311.67,304.57.63-26.97,311.05-124.17,35.95-127.93-35.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m251.15,393.71V105.87l125.42.42-22.37,257.53-103.06,29.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m237.72,140.05h-33.16v191.58l-25.79-4.91v-25.79l-30.7-4.91v57.72l89.65,23.33v-237.02Zm24.87,0h91.79l-6.14,36.72h-50.61v60.26h50.61l-6.14,121.62-79.51,18.42v-38.07l53.72-18.42,3.1-50.35-56.83,8.23v-138.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascriptIcon);
export default __webpack_public_path__ + "static/media/javascript_icon.8273f943b7a9716f914c251c9fec4964.svg";
export { ForwardRef as ReactComponent };